<template>
    <div class="chat-header d-flex flex-wrap align-items-center justify-content-between border-bottom p-3">
        <div class="chat-header-info">
            <small class="info-cell">{{ user.organization.name }}</small>
            <small class="info-cell">
                <div class="avatar">
                    <span v-if="!avatar">{{ getInitials() }}</span>
                    <img v-else :src="avatar" alt="avatar" class="avatar-img" height="40" width="40"/>
                </div>
                {{ user.name }}
            </small>
            <small class="info-cell last">
                <span class="status-bubble" :class="statusClass">{{ getStatusString }}</span>
                <template v-if="chatId">{{ `#Chat - ${chatId}` }}</template>
            </small>
        </div>
        <div v-if="!readOnly" class="chat-header-actions d-flex w-md-auto mt-2 mt-md-1">
            <button
                type="button"
                class="btn transfer-btn"
                :disabled="status === 'resolved' || status === 'reallocating'"
                @click="$emit('transfer')"
            >
                Transfer Chat
            </button>
            <button
                v-if="isWorkfixLine"
                type="button"
                class="btn close-btn"
                :disabled="status === 'resolved' || status === 'reallocating'"
                @click="$emit('inbox-archive')"
            >
                Archive
            </button>
            <button
                type="button"
                class="btn close-btn"
                :disabled="status === 'resolved' || status === 'reallocating'"
                @click="$emit('request-close')"
            >
                {{ isWorkfixLine ? 'Ask if we helped' : 'Close and Archive' }}
            </button>
        </div>
    </div>
</template>
  
<script>
    import avatarManager from '../../utils/avatarManager.js'

    export default {
        name: 'ChatHeader',
        data() {
            return {
                avatar: null
            }
        },
        props: {
            user: {
                type: Object,
                required: true
            },
            chatId: {
                type: [String, Number],
                default: null
            },
            status: {
                type: String,
                required: true
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            isWorkfixLine: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            getStatusString() {
                const result = ({
                    'resolved': 'Archived',
                    'reallocating': 'Tranfering',
                    'new': 'New',
                })[this.status];
                if(!result) {
                    return 'Open'
                }
                return result;
            },
            statusClass() {
                const result = ({
                    'resolved': 'status-archived',
                    'reallocating': 'status-transfering',
                })[this.status];
                if(!result) {
                    return 'status-open'
                }
                return result;
            }
        },
        methods: {
            getInitials() {
                return avatarManager.getAvatar(this.user, (avatarUrl) => {
                    this.avatar = avatarUrl;
                });
            }
        },
        watch: {
            user: {
                handler() {
                    this.getInitials();
                },
                deep: true
            }
        }
    }
</script>
  
<style scoped>
    .chat-header {
        gap: 0.5rem
    }
    .chat-header-info {
        display: flex;
        flex-wrap: wrap;
        flex: 0 0 auto;
        width: max-content;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
    }
    .info-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.8rem;
        padding: 1rem 1.6rem;
        font-size: 1.2rem;
        border-right: 1px solid #ddd;
    }
    .info-cell.last {
        border-right: none;
    }
    .avatar {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 5px;
        background-color: #146F70;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 1.2rem;
    }

    /* Status bubble */
    .status-bubble {
        padding: 0.2rem 0.6rem;
        border-radius: 0.25rem;
        color: #fff;
        font-weight: 600;
    }
    .status-open {
        background-color: #dc3545; 
    }
    .status-archived {
        background-color: #007bff;
    }
    .status-transfering {
        background-color: #FF924E;
    }

    /* Buttons */
    .chat-header-actions {
        gap: 1rem
    }
    .chat-header-actions .btn {
        padding: 1rem 2rem;
        font-size: 1.6rem;
        border-radius: 10px;
        line-height: 1;
        color: #fff;
        font-weight: 600;
    }
    .transfer-btn {
        background-color: #FF924E;
    }
    .close-btn {
        background-color: #2079D5;
    }
</style>
  